import React from 'react';
import Product from './index';
import NestedProduct from './NestedProduct';
import SkeletonLoader from '../SkeletonLoader';
import { useProductDetails } from '../../hooks/useProductDetails';
import { getNoImageSVG, buildProductImageUrl } from '../../utils/imageUtils';

const NestedProductWrapper = ({ productId, productType, section, contentProductId, ...props }) => {
  // Extraire l'ID du produit si c'est un objet, sinon utiliser directement
  const actualProductId = typeof productId === 'object' && productId.id ? productId.id : productId;
  
  // Si productId est déjà un objet produit complet, l'utiliser directement
  const isProductObject = typeof productId === 'object' && productId.name && productId.price;
  
  const { product, isLoading, error } = useProductDetails(isProductObject ? null : actualProductId);


  // Données de fallback basées sur le type de produit
  const getFallbackData = (productType) => {
    const fallbackData = {
      // 'LAMBOURDE': {
      //   name: 'Lambourde',
      //   price: '45.50',
      //   image: getNoImageSVG(),
      //   description: 'Lambourde en bois traité pour construction extérieure',
      //   sku: 'LAM-001'
      // },
      'PLANCHER': {
        name: 'Plancher',
        price: '32.80',
        image: getNoImageSVG(),
        description: 'Plancher en bois massif pour intérieur',
        sku: 'PLA-001'
      },
      'PARQUET': {
        name: 'Parquet',
        price: '28.90',
        image: getNoImageSVG(),
        description: 'Parquet en chêne massif',
        sku: 'PAR-001'
      },
      'LAMBRIS': {
        name: 'Lambris',
        price: '22.40',
        image: getNoImageSVG(),
        description: 'Lambris en pin pour revêtement mural',
        sku: 'LAM-002'
      }
    };
    
    return fallbackData[productType] || {
      name: `Produit ${actualProductId}`,
      price: '0.00',
      image: getNoImageSVG(),
      description: 'Produit de construction en bois',
      sku: `PROD-${actualProductId}`
    };
  };

  if (isLoading) {
    return (
      <div className='col-md-3 col-sm-6 col-12 px-3 mb-5'>
        <SkeletonLoader 
          type="card" 
          width="100%" 
          height="300px"
        />
      </div>
    );
  }

  // Extraire les données du produit de la réponse API
  const extractProductData = (apiResponse) => {
    // Si c'est un objet avec items (structure Magento)
    if (apiResponse && apiResponse.items && apiResponse.items[0]) {
      const productItem = apiResponse.items[0];
      
      // Construire l'URL de l'image selon la logique fournie
      const productImage = buildProductImageUrl(productItem.custom_attributes);
      
      return {
        name: productItem.name || `Produit ${actualProductId}`,
        price: productItem.price ? productItem.price.toString() : '0.00',
        image: productImage,
        description: productItem.description || '',
        sku: productItem.sku || ''
      };
    }
    
    // Si c'est directement l'objet Product selon le modèle fourni
    if (apiResponse && apiResponse.name) {
      // Utiliser l'image du produit ou celle du premier choix s'il y en a
      let productImage = getNoImageSVG();
      
      if (apiResponse.choices && apiResponse.choices.length > 0) {
        const firstChoice = apiResponse.choices[0];
        if (firstChoice.image) {
          productImage = firstChoice.image;
        } else if (firstChoice.profile_image) {
          productImage = firstChoice.profile_image;
        }
      }
      
      return {
        name: apiResponse.name || `Produit ${actualProductId}`,
        price: apiResponse.price ? apiResponse.price.toString() : '0.00',
        image: productImage,
        description: apiResponse.description || '',
        sku: apiResponse.sku || ''
      };
    }
    
    return null;
  };

  // Utiliser les données de l'API si disponibles, sinon fallback
  let apiProductData = null;
  
  if (isProductObject) {
    // Si productId est déjà un objet produit complet, l'utiliser directement
    const productImage = buildProductImageUrl(productId.custom_attributes || []);
    apiProductData = {
      name: productId.name || `Produit ${actualProductId}`,
      price: productId.price ? productId.price.toString() : '0.00',
      image: productImage,
      description: productId.description || '',
      sku: productId.sku || ''
    };
  } else if (product) {
    // Sinon, extraire les données de la réponse API
    apiProductData = extractProductData(product);
  }
  
  const productData = apiProductData || getFallbackData(productType);
  
  console.log('ProductWrapper - productId:', productId, 'actualProductId:', actualProductId, 'isProductObject:', isProductObject, 'productType:', productType, 'product:', product, 'apiProductData:', apiProductData, 'productData:', productData);

  return (
    <NestedProduct
      image={productData.image}
      alt={productData.name}
      price={productData.price}
      checkName={productData.name}
      name={productData.name}
      description={productData.description}
      sku={productData.sku}
      productId={actualProductId}
      section={section}
      productType={productType}
      contentProductId={contentProductId}
      {...props}
    />
  );
};

export default NestedProductWrapper;
